export default "__VITE_ASSET__UKngE3dA__"